import type { ReactNode } from "react";
import React, { useRef } from "react";

import config from "config/appConfig";

import type { Scrollbars } from "react-custom-scrollbars-2";
import { useTranslation } from "react-i18next";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { ToastContainer } from "react-toastify";

import { ScrollToTop } from "shared/Components";

// import { useGlobalScroll } from "shared/hooks";
import type { IApp } from "shared/types";

import "swiper/css";
import "swiper/css/keyboard";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/virtual";

import "./i18n";

const RoutesBlock: React.FC<{ modules: IApp[] }> = ({ modules }) => {
	const scrollerRef = useRef<Scrollbars | null>(null);

	// const { pageScrolledDown, getData: getGlobalScrollData } = useGlobalScroll();
	// const { isDisabled: isDisabledCustomScroll } = getGlobalScrollData();

	const { ready } = useTranslation();

	// const handleScroll = useCallback(
	// 	(values: positionValues) => {
	// 		values.top >= 0.99 && pageScrolledDown();
	// 	},
	// 	[pageScrolledDown]
	// );

	if (!ready) {
		return <p>Loading</p>;
	}

	return (
		<>
			<BrowserRouter key="root">
				<ScrollToTop scrollRef={scrollerRef} />
				<Routes>
					{modules.map(({ getRoutes }) => (getRoutes ? getRoutes() : null) as ReactNode)}
					<Route path="*" element={<Navigate to={{ pathname: config.CORE_URLS.NOT_FOUND }} replace />} />
				</Routes>
			</BrowserRouter>
			<ToastContainer />
		</>
	);
};

export default RoutesBlock;
